import styled, { css, DefaultTheme } from 'styled-components'

export type StatusTagProps = {
  variant?: 'orange' | 'purple' | 'green'
}

const variants = {
  orange: (theme: DefaultTheme) => css`
    background: ${theme.ds.colors.terciary100};
    span {
      color: ${theme.ds.colors.terciary900};
    }
  `,

  purple: (theme: DefaultTheme) => css`
    background: ${theme.ds.colors.secondary100};

    span {
      color: ${theme.ds.colors.secondary900};
    }
  `,

  green: (theme: DefaultTheme) => css`
    background: ${theme.ds.colors.primary100};

    span {
      color: ${theme.ds.colors.primary900};
    }
  `,

  gray: (theme: DefaultTheme) => css`
    background: ${theme.ds.colors.neutral200};

    span {
      color: ${theme.ds.colors.neutral900};
    }
  `
} as any

export const StatusTag = styled.div<any>`
  ${({ variant, theme }) => css`
    width: max-content;
    height: auto;
    margin: 0;
    padding: 0 2px;
    display: flex;
    justify-content: center;
    border-radius: 24px;
    display: flex;
    align-items: center;
    gap: 4px;
    background: transparent;

    span {
      font-style: normal;
      font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
      font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;
      padding: 0 5px;
      width: max-content;
      justify-content: center;
    }

    ${variant && variants[variant](theme)}
  `}
`

export type ContainerProps = Pick<StatusTagProps, 'variant'>
